import { v4 as uuidv4 } from 'uuid'
import { localStorageGetUserID, localStorageSetUser } from '../services/localStorage/localStorageUser'

export function createUserIfNotExists() {
    if (!localStorageGetUserID()) {
        return localStorageSetUser({ id: uuidv4() })
    }
}
